import React from 'react';
import { useBarcode } from 'react-barcodes';
import styles from './BarcodeField.module.scss';

const BarcodeField = ({ 
  formData, 
  errors, 
  isBarcodeFromScan, 
  updateFormData,
  onEnableEdit,
  clearError,
  disabled = false // Add disabled prop with default false
}) => {
  const BarcodeGenerator = ({ value }) => {
    const { inputRef } = useBarcode({
      value: value || 'NO_BARCODE',
      options: {
        background: '#ffffff',
        width: 2,
        height: 100,
        displayValue: true,
        format: "CODE128",
        margin: 10
      }
    });

    if (!value) return null;

    return (
      <div className={styles.barcode_preview}>
        <canvas ref={inputRef} />
      </div>
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Don't process changes if disabled or from scan
    if (name === 'barcode_number' && (isBarcodeFromScan || disabled)) {
      return;
    }
    
    updateFormData(name, value);
    clearError(name); // Clear error on change
  };

  const handleInputFocus = () => {
    clearError('barcode_number'); // Clear error on focus
  };

  // Determine if input should be read-only
  const isReadOnly = isBarcodeFromScan || disabled;

  return (
    <div className={`${styles.label_input} ${errors.barcode_number ? styles.error : ''}`}>
      <label>Barcode Number<span>*</span></label>
      <div className={styles.input_container}>
        <div className={`${styles.barcode_container} ${errors.barcode_number ? styles.error : ''}`}>
          <input
            type="text"
            name="barcode_number"
            value={formData.barcode_number}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            placeholder="Enter Barcode Number"
            readOnly={isReadOnly} // Combined readOnly logic
          />
          {isBarcodeFromScan && !disabled && ( // Only show edit button when not disabled
            <button 
              type="button" 
              className={styles.edit_barcode_btn}
              onClick={onEnableEdit}
            >
              Edit
            </button>
          )}
          {formData.barcode_number && (
            <BarcodeGenerator value={formData.barcode_number} />
          )}
        </div>
        {errors.barcode_number &&
          <span className={styles.errorMessage}>{errors.barcode_number}</span>
        }
      </div>
    </div>
  );
};

export default BarcodeField;